import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import { NavigatorLink } from '../../components/Navigator';
import { imagesPath } from '../../utilities/helpers';
import classNames from 'classnames';
export default function (props, context) {
    function scopeClassNameInactiveClassNameActiveClassNameStyleLinkProps1() {
        var className = 'footer-nav-button';
        var inactiveClassName = `${ className }-unselected`;
        var activeClassName = `${ className }-selected`;
        var style = { textDecoration: 'inherit' };
        var linkProps = {
            className,
            inactiveClassName,
            activeClassName,
            style
        };
        return React.createElement('nav', { 'className': 'footer-nav-bar' }, !this.props.hideHomeButton ? React.createElement(NavigatorLink, _.assign({}, {
            'to': '/',
            'onlyActiveOnIndex': true,
            'key': '612'
        }, linkProps), 'Home') : null);
    }
    return scopeClassNameInactiveClassNameActiveClassNameStyleLinkProps1.apply(this, []);
}